import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import login from './login'
import { setContext } from '@apollo/client/link/context'

const httpLink = createHttpLink({
  uri: `${process.env.VUE_APP_GATEWAY_ENDPOINT || 'http://localhost:4051/'}graphql`,
})

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = login.getToken()
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});


const cache = new InMemoryCache()

export const apolloClient = new ApolloClient({
  // @ts-ignore
  link: authLink.concat(httpLink),
  cache,

})
